import React, { Component } from 'react';
import { connect } from "react-redux";
import Main from './components/Main.js';
import { BrowserRouter, Route, } from "react-router-dom";
import { reactLocalStorage } from 'reactjs-localstorage';
import { getLoginPageInit, } from "./actions/auth/AuthActions";
import { MsalProvider } from '@azure/msal-react';
require('dotenv').config();
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserLoggedIn: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (window.performance.getEntriesByType("navigation")[0].type === 'back_forward' || window.performance.getEntriesByType("navigation")[0].type === 'navigate') { //TO CHECK IF DUPLICATE TAB IS OPENED
      setTimeout(() => {
        window.location.reload();
      }, 200);
    }

    this.props.getLoginPageInit(res => {
      const Data = res?.data?.Data;
      if (!Data) return;

      // Store complete configuration
      reactLocalStorage.setObject('InitialConfiguration', Data);

      // BOP Label
      if (Data.BOPLabel) {
        reactLocalStorage.setObject('BOPLabel', Data.BOPLabel);
      }

      // Base Currency
      if (Data.BaseCurrency) {
        reactLocalStorage.setObject('baseCurrency', Data.BaseCurrency);
      }

      // Costing Heads List - Short and Full Form
      if (Data.CostingHeadsList) {
        const costingHeadsArray = Data.CostingHeadsList.split(",").filter(Boolean);
        const objShort = {};
        const objFull = {};

        costingHeadsArray.forEach(item => {
          const parts = item.split("=");
          const ids = item.match(/\d+/g);
          const id = ids?.[ids.length - 1];

          if (parts[0] && id) objShort[parts[0]] = id;
          if (parts[1] && id) objFull[parts[1]] = id;
        });

        reactLocalStorage.setObject('CostingHeadsListShortForm', objShort);
        reactLocalStorage.setObject('CostingHeadsListFullForm', objFull);
      }

      // Approval Types - Short and Full Form
      if (Data.ApprovalTypeList) {
        const approvalTypesArray = Data.ApprovalTypeList.split(",").filter(Boolean);
        const objShortApp = {};
        const objFullApp = {};

        approvalTypesArray.forEach(item => {
          const parts = item.split('=');
          const shortForm = parts[0]?.trim();
          const fullForm = parts[1]?.trim();
          const id = parts[2]?.trim();

          if (shortForm && id) objShortApp[shortForm] = id;
          if (fullForm && id) objFullApp[fullForm] = id;
        });

        reactLocalStorage.setObject('ApprovalTypeListShortForm', objShortApp);
        reactLocalStorage.setObject('ApprovalTypeListFullForm', objFullApp);
      }

      // Onboarding Configuration
      if (Data?.ApprovalOnboardingList) {
        const [onboardingName = '', onboardingId = ''] = Data?.ApprovalOnboardingList?.split("=");
        reactLocalStorage.setObject('onboardingName', onboardingName);
        reactLocalStorage.setObject('onboardingId', onboardingId);
      }
      // RFQ Part Type Approval IDs - Parse ApprovalRFQArrayList
      // Format: "COMP/ASSY=1,RM=2,BOP=3,Tooling=4"
      if (Data?.ApprovalRFQArrayList) {
        const rfqApprovalTypes = Object.fromEntries(
          Data.ApprovalRFQArrayList.split(",")
            .filter(Boolean)
            .map(item => {
              const [key, value] = item.split("=").map(s => s?.trim());
              return [key, value];
            })
            .filter(([key, value]) => key && value)
        );

        // Store individual IDs as strings (not objects) for RFQ approval flow
        reactLocalStorage.set('componentAssemblyApprovalId', rfqApprovalTypes['COMP/ASSY'] || '');
        reactLocalStorage.set('rawMaterialApprovalId', rfqApprovalTypes['RM'] || '');
        reactLocalStorage.set('boughtOutPartApprovalId', rfqApprovalTypes['BOP'] || '');
        reactLocalStorage.set('toolingApprovalId', rfqApprovalTypes['Tooling'] || '');

      }

      // Module Types
      if (Data.ApprovalModuleTypeList) {
        const moduleType = Object.fromEntries(
          Data.ApprovalModuleTypeList.split(",")
            .filter(Boolean)
            .map(item => item.split("="))
        );
        reactLocalStorage.setObject('moduleType', moduleType);
      }

      // Master Types
      if (Data.ApprovalMasterArrayList) {
        const masterType = Object.fromEntries(
          Data.ApprovalMasterArrayList.split(",")
            .filter(Boolean)
            .map(item => item.split("="))
        );
        reactLocalStorage.setObject('masterType', masterType);
      }

      // Vendor Types
      if (Data?.VendorTypeList) {
        const vendortype = Object.fromEntries(
          Data.VendorTypeList.split(",")
            .filter(Boolean)
            .map(item => item.split("="))
        );
        reactLocalStorage.setObject('vendortype', vendortype);
      }
    })
    reactLocalStorage.setObject('isFromDiscountObj', false)
  }

  /**
  * @method logUserIn
  * @description After user successfully login, flag used internally.
  */
  logUserIn = () => {
    this.setState({ isUserLoggedIn: true });
    reactLocalStorage.setObject("isUserLoggedIn", true);
  }

  /**
   * @method logUserOut
   * @description Used to logout logged in user.
   */
  logUserOut = () => {
    this.setState({ isUserLoggedIn: false });
    // Call MSAL logout method
    this.props.instance.logout();
    // Clear local storage tokens and other relevant data
    reactLocalStorage.setObject('msaltoken', null);
    reactLocalStorage.setObject("isUserLoggedIn", false);
    reactLocalStorage.setObject("userDetail", {});
    reactLocalStorage.set('ModuleId', '');
    reactLocalStorage.setObject('logoutRefresh', true);
    window.location.assign('/login');
    //setTimeout(() => {
    //}, 100)
  }

  render() {

    return (
      <MsalProvider instance={this.props.instance}>
        <BrowserRouter browserHistory>
          <div>
            <Route path="/" render={
              (props) => <Main {...props}
                isUserLoggedIn={this.state.isUserLoggedIn}
                logUserIn={this.logUserIn}
                logUserOut={this.logUserOut}
              />
            } />
          </div>
        </BrowserRouter>
      </MsalProvider>
    );
  }
}


/**
* @method mapStateToProps
* @description return state to component as props
* @param {*} state
*/
function mapStateToProps(state) {
  const { auth } = state;
  const { initialConfiguration } = auth;

  return { initialConfiguration, }
}

export default connect(mapStateToProps, { getLoginPageInit })(App);

